<p class="graph-title font-primary--b">{{title | translate}}</p>
<div
  class="graph-wrapper"
  [class.unsubscribed]="!subscribed"
  [class.wideMode]="wideMode"
  *ngIf="!isEmpty"
>
  <canvas #chartCanvas #{{chartId}} id="{{ chartId }}"></canvas>
  <div class="custom-legend" *ngIf="legend">
    <div class="legend" *ngFor="let label of labels; index as i">
      <div
        class="block"
        [ngStyle]="{ backgroundColor: colors.background[i] }"
      ></div>
      <p class="label">
        {{ label }}
      </p>
    </div>
  </div>
  <div class="unsubscribed-card" *ngIf="!subscribed">
    <p class="description">
      {{ description }}
    </p>
    <div class="text-end">
      <a
        class="mt-2 ms-auto d-block text-red"
        routerLink="/dashboard/membership"
      >
        {{ "chartLabels.unlock-statistics-button" | translate }}
      </a>
    </div>
  </div>
</div>
<div *ngIf="isEmpty">
  <h1 class="graph-title graph-title-no-data"> {{ "chartLabels.no-data" | translate}} </h1>
</div>
